import { createI18n } from 'vue-i18n';
import ar from './locales/ar.json';

const messages = {
  ar,
};

export const i18n = createI18n({
  legacy: false, // Use Vue 3 Composition API
  locale: 'ar', // Default language
  fallbackLocale: 'ar',
  messages,
});
